export default {
  components: {
    stationSelector: {
      title: '역 선택'
    },
    datePicker: {
      title: '날짜 선택'
    }
  },
  dashboard: {
    title: '대시보드'
  }
};
